import { getAuthHeaders } from "@/shared/api/authHeaders";
import { keysToSnakeCase } from "@/shared/lib/case";
// This file is generated by generate-entities.ts. Please DO NOT edit this file directly.
import type { QueryOptions } from "@/shared/lib/tanstack-query";
import {
  type UseQueryResult,
  useQueries,
  useQuery,
} from "@tanstack/react-query";
import { FreightMatching } from "@x-mile/api-contract";
import type { GetContractedCompaniesParams } from "../model";

export const useGetContractedCompanies = (
  params: GetContractedCompaniesParams,
  options?: QueryOptions<typeof FreightMatching.useGetContractedCompanies>,
): UseQueryResult<
  FreightMatching.GetContractedCompaniesQueryResult,
  undefined
> => {
  const authHeaders = getAuthHeaders();
  const result = useQuery({
    ...options,
    queryKey: ["getContractedCompanies", keysToSnakeCase(params)],
    queryFn: () =>
      FreightMatching.getContractedCompanies(
        // バックエンド（rails）ではキーがスネークケースになっているため、クエリパラメータをスネークケースに変換する
        keysToSnakeCase(params),
        {
          headers: authHeaders.isOk() ? authHeaders.value : {},
        },
      ),
  });
  return result as UseQueryResult<
    FreightMatching.GetContractedCompaniesQueryResult,
    undefined
  >;
};

export const useMultipleGetContractedCompanies = (
  paramsList: { [key: string | number]: GetContractedCompaniesParams },
  options?: QueryOptions<typeof FreightMatching.useGetContractedCompanies> & {
    sortFunc?: (
      a: GetContractedCompaniesParams,
      b: GetContractedCompaniesParams,
    ) => number;
  },
): {
  [key: string | number]: UseQueryResult<
    FreightMatching.GetContractedCompaniesQueryResult,
    undefined
  >;
} => {
  const authHeaders = getAuthHeaders();
  const keys = Object.keys(paramsList);
  const sortedKeys = options?.sortFunc
    ? keys.sort((a, b) =>
        options?.sortFunc ? options.sortFunc(paramsList[a], paramsList[b]) : 0,
      )
    : keys;
  const result = useQueries({
    queries: sortedKeys.map((key) => {
      const params = paramsList[key];
      return {
        ...options,
        queryKey: ["getContractedCompanies", keysToSnakeCase(params)],
        queryFn: () =>
          FreightMatching.getContractedCompanies(
            // バックエンド（rails）ではキーがスネークケースになっているため、クエリパラメータをスネークケースに変換する
            keysToSnakeCase(params),
            {
              headers: authHeaders.isOk() ? authHeaders.value : {},
            },
          ),
      };
    }),
  });
  const resultByKeys = Object.fromEntries(
    keys.map((key, i) => [key, result[i]]),
  );
  return resultByKeys as {
    [key: string | number]: UseQueryResult<
      FreightMatching.GetContractedCompaniesQueryResult,
      undefined
    >;
  };
};

// TODO: api-contract側でmockを生成しないことになったので、自前でmockを生成する
// export const useGetContractedCompaniesMock = (
//   params: GetContractedCompaniesParams,
//   options?: QueryOptions<typeof FreightMatching.useGetContractedCompanies>,
// ) => {
//   const [workerStarted, setWorkerStarted] = useState(false);
//   void (async () => {
//     if (!workerStarted) {
//       await FreightMatching.startMockServerWoker(
//         FreightMatching.getGetContractedCompaniesMockHandler(),
//       );
//       setWorkerStarted(true);
//     }
//   })();
//   return useGetContractedCompanies(params, {
//     enabled: workerStarted && options?.enabled,
//   });
// };

// export const useMultipleGetContractedCompaniesMock = (
//   paramsList: { [key: string | number]: GetContractedCompaniesParams },
//   options?: QueryOptions<typeof FreightMatching.useGetContractedCompanies>,
// ) => {
//   const [workerStarted, setWorkerStarted] = useState(false);
//   void (async () => {
//     if (!workerStarted) {
//       await FreightMatching.startMockServerWoker(
//         FreightMatching.getGetContractedCompaniesMockHandler(),
//       );
//       setWorkerStarted(true);
//     }
//   })();
//   return useMultipleGetContractedCompanies(paramsList, {
//     enabled: workerStarted && options?.enabled,
//   });
// };
